const modal = document.getElementById("demoModal");
const iframe = document.getElementById("demoIframe");

document.body.addEventListener("click", (e) => {
  const btn = e.target.closest(".button-demo_template");
  if (!btn) return;

  if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
    const demoUrl = btn.getAttribute("data-href");
    iframe.src = demoUrl;
    modal.style.display = "flex";
  }
});
